import { InputSelectOptions } from 'components'
import { InputField } from 'components/molecules'
import { Form, Formik } from 'formik'
import PropTypes from 'prop-types'
import React from 'react'

const propTypes = {
  handleChangeImageCover : PropTypes.func,
  scraperProduct         : PropTypes.object
}

const defaultProps = {
  handleChangeImageCover : () => {},
  scraperProduct         : {}
}


/**
 * Choose cover image scraper product.
 * @param {func} handleChangeImageCover - Handler to change event on selecting Image Cover
 * @param {object} scraperProduct - Scraper Products data
 */
const ScraperProductImageCoverForm = ({
  scraperProduct,
  handleChangeImageCover
}) => {

  var IMAGES_INDEX = {}
  scraperProduct?.images.forEach((data, index) => IMAGES_INDEX[index + 1] = (index + 1).toString())

  return (
    <Formik
      enableReinitialize={ true }
      initialValues={ scraperProduct }
    >
      {
        (formikBag) => (
          <Form>
            <InputField
              type='select'
              label={ 'Image Cover' }
              name={ 'image_cover' }
              required={ true }
              onChange={ (event) => {
                formikBag.handleChange(event)
                handleChangeImageCover(event)
              } }
            >
              <InputSelectOptions options={ IMAGES_INDEX } keyPrefix={ 'image-cover' } />
            </InputField>

          </Form>
        )
      }
    </Formik>
  )
}

ScraperProductImageCoverForm.defaultProps = defaultProps
ScraperProductImageCoverForm.propTypes    = propTypes

export default ScraperProductImageCoverForm
